import { useContext } from 'react';
import interpolateComponents from 'interpolate-components';
import { SUBSCRIBE_AGREEMENT } from 'src/common/constants/localizations/subscription';
import ExternalLink from '../shared/link/ExternalLink';

import getOverrideOrDefaultResourceKey from '../../utils/getOverrideOrDefaultResourceKey';
import generateOriginLabelFromQuery from '../../utils/generateOriginLabelFromQuery';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './payment.module.scss';

const PaymentDisclaimer = () => {
  const { getLocalizedText, location } = useContext(
    LocationAndLocalizationContext,
  );
  const source = generateOriginLabelFromQuery(location);

  return (
    <div className={css.footer} data-testid="paymentDisclaimer">
      {interpolateComponents({
        mixedString: getLocalizedText(
          getOverrideOrDefaultResourceKey(
            getLocalizedText,
            location,
            SUBSCRIBE_AGREEMENT,
          ),
        ),
        components: {
          a1: (
            <ExternalLink
              dataTestId="termsOfServiceLink"
              href="https://tunein.com/policies/"
              className={css.legalLink}
            />
          ),
          a2: (
            <ExternalLink
              dataTestId="privacyPolicyLink"
              href="https://tunein.com/policies/privacy/"
              className={css.legalLink}
            />
          ),
          a3: (
            <ExternalLink
              data-testid={`${source}Link`}
              href={`https://tunein.com/policies/${source}/`}
              className={css.legalLink}
            />
          ),
        },
      })}
    </div>
  );
};

export default PaymentDisclaimer;
